export interface V2TokenAmounts {
  token0Amount: string
  token1Amount: string
  shareOfPool: string
}

export function calculateV2TokenAmounts(
  liquidityTokenBalance: string,
  totalSupply: string,
  reserve0: string,
  reserve1: string
): V2TokenAmounts {
  if (totalSupply === '0' || liquidityTokenBalance === '0') {
    return {
      token0Amount: '0',
      token1Amount: '0',
      shareOfPool: '0',
    }
  }

  const liquidityBalance = parseFloat(liquidityTokenBalance)
  const supply = parseFloat(totalSupply)
  const reserve0Num = parseFloat(reserve0)
  const reserve1Num = parseFloat(reserve1)

  const shareOfPool = liquidityBalance / supply
  const token0Amount = (reserve0Num * shareOfPool).toString()
  const token1Amount = (reserve1Num * shareOfPool).toString()

  return {
    token0Amount,
    token1Amount,
    shareOfPool: (shareOfPool * 100).toString(), // Convert to percentage
  }
}
